<template>
  <div class="products-spritz-container">
    <app-navbar8 logoSrc="/logo_trans-1500h.png">
      <template v-slot:link1>
        <div class="products-spritz-fragment10">
          <span class="products-spritz-text10">#home</span>
        </div>
      </template>
      <template v-slot:link2>
        <div class="products-spritz-fragment11">
          <span class="products-spritz-text11">#products</span>
        </div>
      </template>
      <template v-slot:link3>
        <div class="products-spritz-fragment12">
          <span class="products-spritz-text12">#services</span>
        </div>
      </template>
      <template v-slot:link4>
        <div class="products-spritz-fragment13">
          <span class="products-spritz-text13">#contact</span>
        </div>
      </template>
      <template v-slot:page1>
        <div class="products-spritz-fragment14">
          <span class="products-spritz-text14">Home</span>
        </div>
      </template>
      <template v-slot:page2>
        <div class="products-spritz-fragment15">
          <span class="products-spritz-text15">Products</span>
        </div>
      </template>
      <template v-slot:page3>
        <div class="products-spritz-fragment16">
          <span class="products-spritz-text16">Services</span>
        </div>
      </template>
      <template v-slot:page4>
        <div class="products-spritz-fragment17">
          <span class="products-spritz-text17">Contact</span>
        </div>
      </template>
      <template v-slot:action1>
        <div class="products-spritz-fragment18">
          <span class="products-spritz-text18">Sign In</span>
        </div>
      </template>
      <template v-slot:action2>
        <div class="products-spritz-fragment19">
          <span class="products-spritz-text19">Create</span>
        </div>
      </template>
      <template v-slot:page1Description>
        <div class="products-spritz-fragment20">
          <span class="products-spritz-text20">Page One Description</span>
        </div>
      </template>
      <template v-slot:page2Description>
        <div class="products-spritz-fragment21">
          <span class="products-spritz-text21">Page Two Description</span>
        </div>
      </template>
      <template v-slot:page3Description>
        <div class="products-spritz-fragment22">
          <span class="products-spritz-text22">Page Three Description</span>
        </div>
      </template>
      <template v-slot:page4Description>
        <div class="products-spritz-fragment23">
          <span class="products-spritz-text23">Page Four Description</span>
        </div>
      </template>
    </app-navbar8>
    <features-spritz
      rootClassName="features-spritzroot-class-name"
      feature1ImageSrc="/holiday-600w.jpg"
      feature2ImageSrc="/hippie1-600w.jpg"
      feature3ImageSrc="/fresh1-600w.jpg"
      feature4ImageSrc="/fresh-200h.jpg"
      feature3ImageSrc1="/garden-600w.jpg"
    >
      <template v-slot:sectionTitle>
        <div class="products-spritz-fragment24">
          <span class="products-spritz-text24">Air Spritz</span>
        </div>
      </template>
      <template v-slot:feature1Title>
        <div class="products-spritz-fragment25">
          <span class="products-spritz-text25">
            <span>
              Holiday Spirit
              <span v-html="rawk82e"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature2Title>
        <div class="products-spritz-fragment26">
          <span class="products-spritz-text28">Hippie</span>
        </div>
      </template>
      <template v-slot:feature3Title>
        <div class="products-spritz-fragment27">
          <span class="products-spritz-text29">Fresh</span>
        </div>
      </template>
      <template v-slot:sectionTitle1>
        <div class="products-spritz-fragment28">
          <span class="products-spritz-text30">Features</span>
        </div>
      </template>
      <template v-slot:feature1Button>
        <div class="products-spritz-fragment29">
          <span class="products-spritz-text31">Buy ($10.00)</span>
        </div>
      </template>
      <template v-slot:feature2Button>
        <div class="products-spritz-fragment30">
          <span class="products-spritz-text32">Buy ($10.00)</span>
        </div>
      </template>
      <template v-slot:feature3Button>
        <div class="products-spritz-fragment31">
          <span class="products-spritz-text33">Buy ($10.00)</span>
        </div>
      </template>
      <template v-slot:feature3Title1>
        <div class="products-spritz-fragment32">
          <span class="products-spritz-text34">Garden</span>
        </div>
      </template>
      <template v-slot:sectionTitle11>
        <div class="products-spritz-fragment33">
          <span class="products-spritz-text35">
            <span>
              All-natural air spritz, crafted with pure essential oils, witch
              hazel, and water.
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature3Button1>
        <div class="products-spritz-fragment34">
          <span class="products-spritz-text38">Buy ($10.00)</span>
        </div>
      </template>
      <template v-slot:feature1Description>
        <div class="products-spritz-fragment35">
          <span class="products-spritz-text39">
            <span>
              Water, witch hazel, and essential oils(pine, bergamot, and clove).
              <span v-html="rawvw2s"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature2Description>
        <div class="products-spritz-fragment36">
          <span class="products-spritz-text42">
            <span>
              Water, witch hazel, and essential oils (patchouli and sweet orange).
              <span v-html="raweis0"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature3Description>
        <div class="products-spritz-fragment37">
          <span class="products-spritz-text45">
            <span>
              Water, witch hazel, and essential oils (juniper, basil, and
              peppermint).
              <span v-html="rawcysc"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
      <template v-slot:feature3Description1>
        <div class="products-spritz-fragment38">
          <span class="products-spritz-text48">
            <span>
              Water, witch hazel, and essential oils (geranium, lavender, and
              rosemary).
              <span v-html="raw6abf"></span>
            </span>
            <br />
          </span>
        </div>
      </template>
    </features-spritz>
    <app-footer4 rootClassName="footer4root-class-name2">
      <template v-slot:termsLink>
        <div class="products-spritz-fragment39">
          <span class="products-spritz-text51">Terms of Service</span>
        </div>
      </template>
      <template v-slot:cookiesLink>
        <div class="products-spritz-fragment40">
          <span class="products-spritz-text52">Cookies Settings</span>
        </div>
      </template>
      <template v-slot:privacyLink>
        <div class="products-spritz-fragment41">
          <span class="products-spritz-text53">Privacy Policy</span>
        </div>
      </template>
    </app-footer4>
  </div>
</template>

<script>
import AppNavbar8 from '../components/navbar8'
import FeaturesSpritz from '../components/features-spritz'
import AppFooter4 from '../components/footer4'

export default {
  name: 'ProductsSpritz',
  props: {},
  components: {
    AppNavbar8,
    FeaturesSpritz,
    AppFooter4,
  },
  data() {
    return {
      rawk82e: ' ',
      rawvw2s: ' ',
      raweis0: ' ',
      rawcysc: ' ',
      raw6abf: ' ',
    }
  },
  metaInfo: {
    title: 'Products-Spritz - Wildwood Herbs',
    meta: [
      {
        property: 'og:title',
        content: 'Products-Spritz - Wildwood Herbs',
      },
    ],
  },
}
</script>

<style scoped>
.products-spritz-container {
  width: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
 
.products-spritz-fragment10 {
  display: contents;
}
 
.products-spritz-text10 {
  display: inline-block;
}
 
.products-spritz-fragment11 {
  display: contents;
}
 
.products-spritz-text11 {
  display: inline-block;
}
 
.products-spritz-fragment12 {
  display: contents;
}
 
.products-spritz-text12 {
  display: inline-block;
}
 
.products-spritz-fragment13 {
  display: contents;
}
 
.products-spritz-text13 {
  display: inline-block;
}
 
.products-spritz-fragment14 {
  display: contents;
}
 
.products-spritz-text14 {
  display: inline-block;
}
 
.products-spritz-fragment15 {
  display: contents;
}
 
.products-spritz-text15 {
  display: inline-block;
}
 
.products-spritz-fragment16 {
  display: contents;
}
 
.products-spritz-text16 {
  display: inline-block;
}
 
.products-spritz-fragment17 {
  display: contents;
}
 
.products-spritz-text17 {
  display: inline-block;
}
 
.products-spritz-fragment18 {
  display: contents;
}
 
.products-spritz-text18 {
  display: inline-block;
}
 
.products-spritz-fragment19 {
  display: contents;
}
 
.products-spritz-text19 {
  display: inline-block;
}
 
.products-spritz-fragment20 {
  display: contents;
}
 
.products-spritz-text20 {
  display: inline-block;
}
 
.products-spritz-fragment21 {
  display: contents;
}
 
.products-spritz-text21 {
  display: inline-block;
}
 
.products-spritz-fragment22 {
  display: contents;
}
 
.products-spritz-text22 {
  display: inline-block;
}
 
.products-spritz-fragment23 {
  display: contents;
}
 
.products-spritz-text23 {
  display: inline-block;
}
 
.products-spritz-fragment24 {
  display: contents;
}
 
.products-spritz-text24 {
  display: inline-block;
}
 
.products-spritz-fragment25 {
  display: contents;
}
 
.products-spritz-text25 {
  display: inline-block;
}
 
.products-spritz-fragment26 {
  display: contents;
}
 
.products-spritz-text28 {
  display: inline-block;
}
 
.products-spritz-fragment27 {
  display: contents;
}
 
.products-spritz-text29 {
  display: inline-block;
}
 
.products-spritz-fragment28 {
  display: contents;
}
 
.products-spritz-text30 {
  display: inline-block;
}
 
.products-spritz-fragment29 {
  display: contents;
}
 
.products-spritz-text31 {
  display: inline-block;
}
 
.products-spritz-fragment30 {
  display: contents;
}
 
.products-spritz-text32 {
  display: inline-block;
}
 
.products-spritz-fragment31 {
  display: contents;
}
 
.products-spritz-text33 {
  display: inline-block;
}
 
.products-spritz-fragment32 {
  display: contents;
}
 
.products-spritz-text34 {
  display: inline-block;
}
 
.products-spritz-fragment33 {
  display: contents;
}
 
.products-spritz-text35 {
  display: inline-block;
}
 
.products-spritz-fragment34 {
  display: contents;
}
 
.products-spritz-text38 {
  display: inline-block;
}
 
.products-spritz-fragment35 {
  display: contents;
}
 
.products-spritz-text39 {
  display: inline-block;
}
 
.products-spritz-fragment36 {
  display: contents;
}
 
.products-spritz-text42 {
  display: inline-block;
}
 
.products-spritz-fragment37 {
  display: contents;
}
 
.products-spritz-text45 {
  display: inline-block;
}
 
.products-spritz-fragment38 {
  display: contents;
}
 
.products-spritz-text48 {
  display: inline-block;
}
 
.products-spritz-fragment39 {
  display: contents;
}
 
.products-spritz-text51 {
  display: inline-block;
}
 
.products-spritz-fragment40 {
  display: contents;
}
 
.products-spritz-text52 {
  display: inline-block;
}
 
.products-spritz-fragment41 {
  display: contents;
}
 
.products-spritz-text53 {
  display: inline-block;
}
</style>
